import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { get, post } from '../../utils/api';
import { Button } from '../shadcn/button';

function DashboardCoreSkillRoute() {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const { loggedInChild } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    const redirectToCoreSkillPlayer = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get('sessionId');
        const source = params.get('source') || 'dashboard_progress';

        if (!loggedInChild?._id) {
          if (mounted) setError('Please log in as a child first, then retry the core skill lesson.');
          return;
        }

        const coreSkillsTopic = await get('/topics/search?topic=Core Skills', true);
        if (!coreSkillsTopic?._id) {
          throw new Error('Core Skills topic not found');
        }

        // Align dashboard core-skill lesson pointer with the selected lesson.
        await post(
          '/childTopics/start-learning-dashboard-core-skill',
          { childId: loggedInChild._id, topicId: coreSkillsTopic._id, lessonId },
          true,
        );

        if (!mounted) return;
        const nextParams = new URLSearchParams({
          isCoreSkill: 'true',
          coreSkillTopicId: coreSkillsTopic._id,
          source,
        });
        if (sessionId) {
          nextParams.set('dashboardSessionId', sessionId);
        }

        navigate(
          `/core-skills/learn/${lessonId}?${nextParams.toString()}`,
          { replace: true },
        );
      } catch (err) {
        if (!mounted) return;
        setError('Unable to open the core skill lesson right now.');
      }
    };

    redirectToCoreSkillPlayer();
    return () => {
      mounted = false;
    };
  }, [lessonId, loggedInChild?._id, navigate]);

  return (
    <div className="container mx-auto p-4">
      {error ? (
        <div className="p-4 rounded-md border border-red-200 bg-red-50 text-red-700">
          <p>{error}</p>
          <Button onClick={() => navigate('/dashboard')} className="mt-3">
            Back to Dashboard
          </Button>
        </div>
      ) : (
        <div className="py-10 flex items-center gap-2 text-gray-600">
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600" />
          <span>Opening core skill lesson...</span>
        </div>
      )}
    </div>
  );
}

export default DashboardCoreSkillRoute;
